export enum FileType {
    PDF = 'pdf',
    XLS = 'xls',
    XLSX = 'xlsx',
    JPG = 'jpg',
    JPEG = 'jpeg',
    PNG = 'png',
}
